import React from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { BarChart } from "@mui/x-charts/BarChart";
import { Typography } from "@mui/material";
import { LineChart, cheerfulFiestaPaletteDark } from "@mui/x-charts";
import { PieChart } from "@mui/x-charts";

export const HiddenTypography = () => {
  const { t } = useTranslation("statistics");

  <Typography
    sx={{
      textAlign: "center",
      marginTop: "10px",
      visibility: "hidden",
    }}
  >
    {t("empty.noDataWeek")}
  </Typography>;
};
export function BarChartEmpty({ weekDays, chartWidth }) {
  const { t } = useTranslation("statistics");

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          marginTop: "10px",
        }}
      >
        {t("empty.noDataWeek")}
      </Typography>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: weekDays.map((day) => format(day, "EEE")),
            padding: 0.2,
          },
        ]}
        series={[
          {
            data: weekDays.map(() => 0),
          },
        ]}
        width={chartWidth}
        height={300}
        slotProps={{
          legend: { hidden: true },
        }}
      />
    </>
  );
}

export function BarChartEmptyHorizontically({ weekDays, chartWidth }) {
  const { t } = useTranslation("statistics");

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          marginTop: "10px",
        }}
      >
        {t("empty.noDataWeek")}
      </Typography>
      <BarChart
        yAxis={[
          {
            scaleType: "band",
            data: weekDays.map((day) => format(day, "EEE")),
          },
        ]}
        series={[
          {
            data: weekDays.map(() => 0),
          },
        ]}
        layout="horizontal"
        width={chartWidth}
        height={300}
      />
    </>
  );
}

export function EmptyLineChart({ weekDays, chartWidth }) {
  const { t } = useTranslation("statistics");
  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          marginTop: "10px",
        }}
      >
        {t("empty.noDataWeek")}
      </Typography>
      <LineChart
        colors={cheerfulFiestaPaletteDark}
        xAxis={[
          {
            scaleType: "band",
            data: weekDays.map((day) => format(day, "EEE")),
          },
        ]}
        series={[
          {
            data: weekDays.map(() => 0),
            area: true,
          },
        ]}
        width={chartWidth}
        height={300}
      />
    </>
  );
}

export function PieChartEmpty({
  title,
  chartWidth,
  height,
  pieProps,
  pieChartLabelDirection,
  pieChartLabelPosition,
  pieChartPaddingLabel,
}) {
  const { t } = useTranslation("statistics");

  return (
    <>
      <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
        {t("empty.noDataTitle", { title })}
      </Typography>
      <PieChart
        series={[
          {
            data: [
              {
                id: 0,
                value: 100,
                label: "NO DATA",
              },
            ],
            //  cx: 130,
            //  cy:120
            ...pieProps,
          },
        ]}
        width={chartWidth}
        height={height}
        slotProps={{
          legend: {
            direction: pieChartLabelDirection,
            position: pieChartLabelPosition,
            padding: pieChartPaddingLabel.secondPie,
            itemMarkWidth: 20,
            itemMarkHeight: 3,
            markGap: 5,
            itemGap: 5,
          },
        }}
      />
    </>
  );
}

export const BarChartEmptyComponent = ({ chartWidth, height, title }) => {
  const { t } = useTranslation("statistics");

  <>
    <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
     {t("empty.noDataTitle", { title })}
    </Typography>
    <BarChart
      width={chartWidth}
      height={height}
      xAxis={[
        {
          scaleType: "band",
          data: ["No Data"],
        },
      ]}
      series={[
        {
          data: [0],
        },
      ]}
    />
  </>;
};
